import React from "react";
import { useOutletContext } from "react-router-dom";
import { Button, CheckBoxInput, DownloadAgreement } from "@/components";
import { IoArrowForward } from "react-icons/io5";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaCheck } from "react-icons/fa";
import { IoCheckmark } from "react-icons/io5";
import { useConfirmationDialog } from "@/";
const SellerAgreement = () => {
  const {
    handleSubmit,
    handlePreviousStep,
    isDisabled,
    handleIsReject,
    handleApprove,
    kycStatus,
    handleUnblock,
    handleBlock,
  } = useOutletContext(); // Get handleNextStep from context
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [sellerAgreement, setSellerAgreement] = useState(false);
  const status = kycStatus;
  const handleSendForVerification = (e) => {
    e.preventDefault();
    handleSubmit();
  };
  const block = (e) => {
    e.preventDefault();
    handleBlock();
  };
  const unBlock = (e) => {
    e.preventDefault();
    handleUnblock();
  };
  const handleReject = (e) => {
    e.preventDefault();
    handleIsReject();
  };
  const handleApproveKyc = (e) => {
    e.preventDefault();
    handleApprove();
  };

  return (
    <div className="flex flex-col gap-4 md:gap-4 p-2">
      <div>
        <h2 className="md:text-headline3 text-headline4 font-nunito text-secondary-90 font-bold">
          Seller Agreement
        </h2>
        <p className="text-body2 md:text-body1 text-secondary/60 font-ptsans w-full md:w-[60%]">
          Download the agreement form, fill it out by hand, create a PDF, and
          then upload it back below.
        </p>
      </div>
      <DownloadAgreement disabled={isDisabled} />

      <div className="flex flex-row gap-1 md:gap-2 justify-between sm:justify-end mt-8 mr-2">
        <Button size="sm" variant="outline" onClick={handlePreviousStep}>
          Previous
        </Button>

        {status !== "rejected" && (
          <Button
            size="sm"
            variant="default"
            className="!bg-[#D62525]/90 !text-background"
            onClick={handleReject}
            icon={RxCross2}
          >
            Reject KYC
          </Button>
        )}

        {/* Reject & Approve Buttons - Only if KYC is not yet approved/rejected */}
        {status !== "approved" && (
          <>
            <Button
              size="sm"
              variant="default"
              className="!bg-green-500/90 !text-background"
              onClick={handleApproveKyc}
              icon={IoCheckmark}
            >
              Approve KYC
            </Button>
          </>
        )}

        {/* Update KYC Button - Only visible when isDisabled is false */}
        {!isDisabled && (
          <Button
            size="sm"
            variant="default"
            className="!bg-blue-500/90 !text-background"
            onClick={handleSendForVerification}
            icon={IoCheckmark}
          >
            Update KYC
          </Button>
        )}
      </div>
    </div>
  );
};

export default SellerAgreement;
